import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useRef, useState } from "react";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Filter, ISalRepFilter, EmptySalRepFilter } from "./Filter";
import { SubTable } from "./SubTable";
import { ILogin, IPermissionProps } from "../../../models/Login";
import { Accordion, AccordionTab } from "primereact/accordion";
import { format } from "date-fns";

interface ISalesReport {
    login_ID?: number,
    sales?: string,
    branchName?: string,
    salID?: number,
    onsite?: number,
    hybrid?: number,
    remote?: number,
    f2F?: number,
    noF2F?: number,
    numberOfContact?: number,
    unserved?: number,
    served?: number,
    per?: number,
    subRec?: number,
    accSub?: number,
    rejSub?: number
}

export const SalesReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISalesReport>, loading: boolean });
    const [tFooter, setTFooter] = useState<ISalesReport>({});
    const [salRepFilter, setSalRepFilter] = useState<ISalRepFilter>(EmptySalRepFilter);
    const [excelLoading, setExcelLoading] = useState<boolean>(false);
    const [tableLoad, setTableLoad] = useState(false);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);


    let _role: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _role.push(role.role_ID);
    });

    const [filter, setFilter] = useState(false);
    const hideFilterDialog = () => {
        setFilter(false);
    };

    const [subTable, setSubTable] = useState({ open: false, salesID: 0, resType: 0 } as { open: boolean, salesID: number, resType: number });
    const hideSubTableDialog = () => {
        setSubTable({ open: false, salesID: 0, resType: 0 });
    };

    useEffect(() => {
        if(tableLoad){
        loadTableData();
        setTableLoad(false);
        }
    }, [salRepFilter]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Report_Sales", "GET", null, `filter=${JSON.stringify(salRepFilter)}`, toast);
        if (response) {
            const data: Array<ISalesReport> = await response.json();

            const _data: Array<ISalesReport> = [];
            let totalsalID = 0;
            let totalonsite = 0;
            let totalhybrid = 0;
            let totalremote = 0;
            let totalf2F = 0;
            let totalnoF2F = 0;
            let totalnumberOfContact = 0;
            let totalunserved = 0;
            let totalserved = 0;
            let totalsubRec = 0;
            let totalaccSub = 0;
            let totalrejSub = 0;
            data.forEach((d, i) => {
                if (d.salID) totalsalID += d.salID;
                if (d.onsite) totalonsite += d.onsite;
                if (d.hybrid) totalhybrid += d.hybrid;
                if (d.remote) totalremote += d.remote;
                if (d.f2F) totalf2F += d.f2F;
                if (d.noF2F) totalnoF2F += d.noF2F;
                if (d.numberOfContact) totalnumberOfContact += d.numberOfContact;
                if (d.unserved) totalunserved += d.unserved;
                if (d.served) totalserved += d.served;
                if (d.subRec) totalsubRec += d.subRec;
                if (d.accSub) totalaccSub += d.accSub;
                if (d.rejSub) totalrejSub += d.rejSub;
                _data.push(d);
            });
            const totalRecords: ISalesReport = {
                sales: "Total Records",
                salID: totalsalID,
                onsite: totalonsite,
                hybrid: totalhybrid,
                remote: totalremote,
                f2F: totalf2F,
                noF2F: totalnoF2F,
                numberOfContact: totalnumberOfContact,
                unserved: totalunserved,
                served: totalserved,
                subRec: totalsubRec,
                accSub: totalaccSub,
                rejSub: totalrejSub,
            };
            setTFooter(totalRecords);

            setTableData({ tableData: _data, loading: false });
        }
    }

    const rightToolbarTemplate = () => {
        const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
        return (
            permissions.is_Export || loginObj.is_Team_Lead ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Sales Performance Report</h5>
            {/* <span className="block mt-2 md:mt-0 p-input-icon-left">
                <Button icon="pi pi-filter" onClick={() => setFilter(true)} className="p-button-rounded p-button-secondary ml-2" aria-label="Filter" />
            </span> */}
        </div>
    );

    const fnumberOfContact = <div style={{ fontWeight: 'bold' }}>{tFooter.numberOfContact}</div>
    const fsalID = <div style={{ fontWeight: 'bold' }}>{tFooter.salID}</div>
    const fonsite = <div style={{ fontWeight: 'bold' }}>{tFooter.onsite}</div>
    const fhybrid = <div style={{ fontWeight: 'bold' }}>{tFooter.hybrid}</div>
    const fremote = <div style={{ fontWeight: 'bold' }}>{tFooter.remote}</div>
    const ff2F = <div style={{ fontWeight: 'bold' }}>{tFooter.f2F}</div>
    const fnoF2F = <div style={{ fontWeight: 'bold' }}>{tFooter.noF2F}</div>
    const funserved = <div style={{ fontWeight: 'bold' }}>{tFooter.unserved}</div>
    const fserved = <div style={{ fontWeight: 'bold' }}>{tFooter.served}</div>
    const fsubRec = <div style={{ fontWeight: 'bold' }}>{tFooter.subRec}</div>
    const faccSub = <div style={{ fontWeight: 'bold' }}>{tFooter.accSub}</div>
    const frejSub = <div style={{ fontWeight: 'bold' }}>{tFooter.rejSub}</div>


    const numberOfContact = (rowData: ISalesReport) => <span onClick={() => { (!_role.includes(40)) ? rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 1 }) : setSubTable({ open: false, salesID: 0, resType: 1 }) }} className="cursor-pointer text-cyan-700 underline">{rowData.numberOfContact}</span>
    const onsite = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 3 })} className="cursor-pointer text-cyan-700 underline">{rowData.onsite}</span>
    const hybrid = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 4 })} className="cursor-pointer text-cyan-700 underline">{rowData.hybrid}</span>
    const remote = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 5 })} className="cursor-pointer text-cyan-700 underline">{rowData.remote}</span>
    const f2F = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 6 })} className="cursor-pointer text-cyan-700 underline">{rowData.f2F}</span>
    const noF2F = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 7 })} className="cursor-pointer text-cyan-700 underline">{rowData.noF2F}</span>
    const salID = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 2 })} className="cursor-pointer text-cyan-700 underline">{rowData.salID}</span>
    const unserved = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 8 })} className="cursor-pointer text-cyan-700 underline">{rowData.unserved}</span>
    const served = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 9 })} className="cursor-pointer text-cyan-700 underline">{rowData.served}</span>
    // const per = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 10 })} className="cursor-pointer text-cyan-700 underline">{rowData.per}</span>
    const subRec = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 11 })} className="cursor-pointer text-cyan-700 underline">{rowData.subRec}</span>
    const accSub = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 12 })} className="cursor-pointer text-cyan-700 underline">{rowData.accSub}</span>
    const rejSub = (rowData: ISalesReport) => <span onClick={() => rowData.login_ID && setSubTable({ open: true, salesID: rowData.login_ID, resType: 13 })} className="cursor-pointer text-cyan-700 underline">{rowData.rejSub}</span>


    const downloadExcel = async (exceltype: number) => {
        setExcelLoading(p => p = true);
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"Report_Sales/getexcel"}?` + `filter=` + encodeURIComponent(JSON.stringify(salRepFilter)) + `&exceltype=${exceltype}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `Report_SalesReport.xlsx`;
                a.href = href;
                a.click();
                a.href = '';
                setExcelLoading(p => p = false);
            } else if (response.status === 400) {
                const message = await response.text();
                toast.current.show({ severity: 'error', detail: message, life: 3000 });
                setExcelLoading(p => p = false);
            }
        } catch {
            setExcelLoading(p => p = false);
            toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }


    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter salRepFilter={salRepFilter} setSalEffFilter={setSalRepFilter} downloadExcel={downloadExcel} excelLoading={excelLoading} onSearch={() => setTableLoad(true)}/>
                </AccordionTab>
            </Accordion>



            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns showGridlines columnResizeMode="expand" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                ref={dt} size="small" stripedRows scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
            >
                <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} footer={tFooter.sales} />
                <Column field="sales" header="Sales Manager" sortable body={(rowData) => <p style={{ color: rowData.user_Status ? "red" : "" }}>{rowData.sales}</p>} />
                <Column field="branchName" header="Sales Comp(Branch)" sortable />
                <Column field="teamManager" header="Team Manager" sortable />
                <Column field="numberOfContact" header="Client" sortable body={numberOfContact} footer={fnumberOfContact} />
                <Column field="salID" header="Req" sortable body={salID} footer={fsalID} />
                <Column field="served" header="Served" sortable body={served} footer={fserved} />
                <Column field="per" header="Per" sortable />
                <Column field="unserved" header="Unserved" sortable body={unserved} footer={funserved} />
                <Column field="onsite" header="Onsite" sortable body={onsite} footer={fonsite} />
                <Column field="hybrid" header="Hybrid" sortable body={hybrid} footer={fhybrid} />
                <Column field="remote" header="Remote" sortable body={remote} footer={fremote} />
                <Column field="f2F" header="F2F" sortable body={f2F} footer={ff2F} />
                <Column field="noF2F" header="Phone/Skype" sortable body={noF2F} footer={fnoF2F} />
                <Column field="subRec" header="Sub Rcvd" sortable body={subRec} footer={fsubRec} />
                <Column field="accSub" header="Sub Acpt" sortable body={accSub} footer={faccSub} />
                <Column field="rejSub" header="Sub Rej" sortable body={rejSub} footer={frejSub} />
            </DataTable>
            <SubTable open={subTable.open} salesID={subTable.salesID} resType={subTable.resType} hideDialog={hideSubTableDialog} toast={toast} salEffFilter={salRepFilter} />
            {/* <Filter open={filter} hideDialog={hideFilterDialog} setSalEffFilter={setSalRepFilter} toast={toast} /> */}
            <Toast ref={toast} />
        </>
    );
}
